import { pathJoin } from 'src/reducers/routing/utils'

export const createKmdEasyRoutesMap = (prefix: string) => ({
  delta: pathJoin(prefix)('delta').chain,
  total: pathJoin(prefix)('total').chain,
  imports: pathJoin(prefix)('imports').chain,
  ftp: pathJoin(prefix)('ftp').chain,
  'property-types': pathJoin(prefix)('property-types').chain,
})
